import {
  getBattlePerfProbe,
  getWsInboundDelayMs,
  installBattlePerfGlobalExport,
  isBattlePerfEnabled,
  startLongTaskObserver,
} from './battlePerfProbe';

let initialized = false;

function ensureInitialized() {
  if (initialized || !isBattlePerfEnabled()) {
    return;
  }
  initialized = true;
  startLongTaskObserver();
  installBattlePerfGlobalExport();
  console.log('[BattlePerf] Probe active — export via window.__codaExportBattlePerf()');
}

/**
 * Wrap the game WebSocket onmessage handler. Returns the original handler when perf mode is off.
 * @param {(event: MessageEvent) => void} handler
 */
export function createBattleWsMessageWrapper(handler) {
  if (!isBattlePerfEnabled()) {
    return handler;
  }
  ensureInitialized();

  const inboundDelayMs = getWsInboundDelayMs();

  const runWrapped = (event) => {
    const probe = getBattlePerfProbe();
    if (!probe) {
      handler(event);
      return;
    }

    let ctx = probe.beginInboundMessage(event.data, event.__codaWireByteLength);
    let msg;
    try {
      msg = JSON.parse(event.data);
    } catch (err) {
      console.error('Failed to parse WebSocket message:', err);
      return;
    }
    ctx = probe.recordParsed(ctx, msg);

    event.__battlePerfParsed = msg;
    try {
      handler(event);
    } finally {
      delete event.__battlePerfParsed;
      probe.recordHandlerComplete(ctx);
    }
  };

  if (inboundDelayMs <= 0) {
    return (event) => runWrapped(event);
  }

  return (event) => {
    setTimeout(() => runWrapped(event), inboundDelayMs);
  };
}

/**
 * Call after React setGameState from authoritative WS updates (via useGameStateSync callback).
 */
export function onBattleStateUpdateForPerf(_newState) {
  if (!isBattlePerfEnabled()) {
    return;
  }
  const probe = getBattlePerfProbe();
  if (!probe) {
    return;
  }

  const commitStart = performance.now();
  queueMicrotask(() => {
    probe.recordCommit(performance.now() - commitStart);
    const paintStart = performance.now();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        probe.recordPaint(performance.now() - paintStart);
      });
    });
  });
}

export { isBattlePerfEnabled };
